import { leafStyleLayoutBeamHeightOffsetByCode } from "entities/configurator/model/layoutGeometry";
import { EigenwijsOptions } from "./DoorOptionsProvider.types";

export const clampDoorHeight = (
  height: number,
  minDoorHeight: number,
  maxDoorHeight: number,
): number => Math.min(Math.max(height, minDoorHeight), maxDoorHeight);

export const applyHeightToEigenwijs = (
  eigenwijs: EigenwijsOptions,
  height: number,
  layoutCode: string | null | undefined,
): EigenwijsOptions => {
  const nextBeams = [...eigenwijs.beams];
  const nextEigenwijs = {
    ...eigenwijs,
    beams: nextBeams,
    sizeObjects: eigenwijs.sizeObjects.map((sizeObject) => ({
      ...sizeObject,
      customHeight: height,
    })),
  };
  const beamHeightOffset = layoutCode
    ? leafStyleLayoutBeamHeightOffsetByCode[layoutCode]
    : undefined;

  if (beamHeightOffset !== undefined && nextBeams[0]) {
    nextBeams[0] = {
      ...nextBeams[0],
      height: height - beamHeightOffset,
    };
  }

  return nextEigenwijs;
};
